$(document).ready(function () {
  setTimeout(function () {
    $(".div-block-94").css({
      opacity: "1",
      transform: "translateY(0)",
    });
  }, 500); // 500 milliseconds = 0.5 seconds

  $("body").addClass("withBackgroundImage");

  $("#mobileMenuButton").click(function () {
    $("#mobileNav").slideToggle();
  });

  $("#mobileNav a").click(function () {
    $("#mobileNav").slideToggle();
  });

  $(".testimonial-tab-link-large").click(function (event) {
    event.preventDefault();

    // Remove 'w--current' class and reset aria-selected and opacity for all tabs
    $(".testimonial-tab-link-large")
      .removeClass("w--current")
      .attr("aria-selected", "false")
      .find(".tab-link-line")
      .css("opacity", "0");

    // Add 'w--current' class, set aria-selected to true, and update opacity for the clicked tab
    $(this)
      .addClass("w--current")
      .attr("aria-selected", "true")
      .find(".tab-link-line")
      .css("opacity", "1");

    // Hide all tab panes
    $(".w-tab-pane").removeClass("w--tab-active").css("opacity", "0");

    // Show the corresponding tab pane
    var target = $(this).attr("href");
    $(target).addClass("w--tab-active").css("opacity", "1");
  });

  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      header.addClass("sticky");
    } else {
      header.removeClass("sticky");
    }
  });

  $("#logo-carousel-group").addClass("scrolling");

  function checkCustomVisibility() {
    $(".customFadeInElement").each(function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $(this).addClass("customVisible");
      }
    });
  }

  $(window).on("scroll resize", checkCustomVisibility);
  $(window).trigger("scroll");

  function adjustRowHeight() {
    if ($(window).width() < 768) {
      // Target mobile devices
      var colHeight = $("#deviceComparo .col-md-3").first().outerHeight();
      //$("#deviceComparo .row").css("height", colHeight);
    } else {
      //$("#deviceComparo .row").css("height", "auto");
    }
  }

  // Adjust height on page load
  adjustRowHeight();

  // Adjust height on window resize
  $(window).resize(function () {
    adjustRowHeight();
  });

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  // Add active class on click
  $(".nav-link-3.scrollToAnchorLink").on("click", function (event) {
    event.preventDefault();
    $(".nav-link-3").removeClass("active");
    $(this).addClass("active");

    var target = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  });

  // Add active class on scroll
  $(window).on("scroll", function () {
    var scrollPos = $(window).scrollTop();

    $(".nav-link-3").each(function () {
      //var sectionOffset = $($(this).attr("href")).offset().top - 100;
      var sectionOffset = $(this).offset().top - 100;
      if (scrollPos >= sectionOffset) {
        $(".nav-link-3").removeClass("active");
        $(this).addClass("active");
      }
    });
  });
});
